import React from 'react';

/**
 * Compact page header: title, optional record count, filter controls and
 * actions, all on one line from `md` up.
 *
 * On phones the first line keeps the title and the actions while the filters
 * drop to a full-width second line and stretch to fill it, so nothing is
 * squeezed into unusable 40px inputs.
 */
export default function PageToolbar({ title, count, filters, actions, className = '' }) {
    return (
        <div
            className={`flex flex-wrap items-center gap-x-2 gap-y-2 px-2.5 sm:px-3 py-2 border-b border-slate-100 ${className}`}
        >
            {title ? (
                <h1 className="order-1 m-0 text-sm sm:text-[15px] font-semibold text-slate-800 shrink-0 truncate max-w-[55%] sm:max-w-[60%] md:max-w-none">
                    {title}
                </h1>
            ) : null}

            {count != null && (
                <span className="order-1 text-xs text-slate-400 tabular-nums shrink-0">{count}</span>
            )}

            {filters && (
                <>
                    <div className="order-1 hidden md:block w-px h-4 bg-slate-200 mx-1 shrink-0" />
                    <div className="order-3 md:order-1 w-full md:w-auto flex flex-wrap items-center gap-2 [&>*]:flex-1 [&>*]:basis-[132px] md:[&>*]:flex-none md:[&>*]:basis-auto">
                        {filters}
                    </div>
                </>
            )}

            {actions && <div className="order-2 ms-auto flex items-center gap-1.5 shrink-0">{actions}</div>}
        </div>
    );
}
